"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInputFormik = void 0;
var React = require("react");
var __1 = require("..");
var PasswordInputFormik_styles_1 = require("./PasswordInputFormik.styles");
exports.PasswordInputFormik = React.forwardRef(function (_a, ref) {
    var Autocomplete = _a.Autocomplete, Name = _a.Name, FormikProps = _a.FormikProps, Label = _a.Label, MaxLength = _a.MaxLength, HelperText = _a.HelperText, Placeholder = _a.Placeholder, Disabled = _a.Disabled, ShowRequired = _a.ShowRequired;
    return React.createElement(__1.FormikWrapper, { Label: Label, HelperText: HelperText, Name: Name, FormikProps: FormikProps, Disabled: Disabled, ShowRequired: ShowRequired, RenderControl: function (id, props, hasErrors) { return React.createElement(PasswordInputFormik_styles_1.Input, __assign({}, __1.AddBasicParameters(id, props, hasErrors, Disabled, ShowRequired), { placeholder: Placeholder, type: "password", autoComplete: Autocomplete || "off", maxLength: MaxLength || undefined, ref: ref })); } });
});
